import { FormControlLabel, Switch, Typography } from "@mui/material";
import { useState } from "react";
import { featureFlags } from "../featureFlags/featureFlags";

export default function NewUiButton() {
  const [enabled, setEnabled] = useState(() => featureFlags.enabled("packages2.0") && featureFlags.enabled("login2.0"));

  function handleChange(checked: boolean) {
    if (checked) {
      featureFlags.admin.enable("packages2.0");
      featureFlags.admin.enable("login2.0");
      featureFlags.admin.enable("appbar2.0");
    } else {
      featureFlags.admin.disable("packages2.0");
      featureFlags.admin.disable("login2.0");
      featureFlags.admin.disable("appbar2.0");
    }
    setEnabled(checked);
    window.location.reload();
  }
  return (
    <FormControlLabel
      control={<Switch checked={enabled} onChange={(e) => handleChange(e.target.checked)} color="default" />}
      label={
        <Typography
          sx={
            enabled
              ? {
                  color: "inherit",
                  opacity: 0.7,
                  fontSize: "0.875rem",
                  fontWeight: "normal",
                }
              : {
                  textTransform: "uppercase",
                  color: "inherit",
                  fontSize: "0.875rem",
                }
          }
        >
          Nowy widok
        </Typography>
      }
    />
  );
}
